import * as React from "react"

const EmptyMessage = ({ children, dataLoaded }: any) => {
  return !dataLoaded && <div>{children}</div>
}

export default EmptyMessage
